import * as yup from "yup";

const CargaMasivaValidacionEsquema = yup.object().shape({
    vigencia: yup.mixed().required(),
    archivo: yup.mixed().required(),
    tipoDocumento : yup.mixed().required()
});

export default CargaMasivaValidacionEsquema;